export const styles = {
  sectionWrapper: {
    borderRadius: { lg: '50px' },
    overflow: 'hidden',
    m: { lg: '60px 40px' },
    width: 'calc(100%+0px)',
  },
  employmentblock: (theme) => ({
    display: 'flex',
    justifyContent: 'flex-start',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '0',
    gap: '30px',
    borderRadius: '50px',
    backgroundColor: '#F8F6FC',
    [theme.breakpoints.up('sm')]: {
      padding: '40px 60px 80px',
      margin: '40px auto',
    },
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
      backgroundColor: 'inherit',
      borderRadius: '0',
      padding: '32px 16px',
    },
  }),
  main: (theme) => ({
    flexDirection: 'column',
    justifyContent: 'center',
    '> div > section': {
      padding: 0,
      [theme.breakpoints.up('lg')]: {
        h2: {
          margin: '8px 0 24px',
          wordSpacing: '500px',
        },
      },
      [theme.breakpoints.up('sm')]: {
        backgroundColor: '#F8F6FC',
      },
      '> div': {
        padding: 0,
      },
    },
  }),
  sectionBlock: {
    justifySelf: 'end',
  },
  description: (theme) => ({
    color: '#666666',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '18px',
    lineHeight: '145%',
    maxWidth: '470px',
    alignSelf: 'flex-start',
    marginBottom: '32px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
    },
  }),
  programsBlock: (theme) => ({
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    [theme.breakpoints.up('sm')]: {
      justifyContent: 'right',
    },
  }),
  companies: (theme) => ({
    fontFamily: 'RF Rostin',
    fontSize: '34px',
    lineHeight: '130%',
    letterSpacing: '-0.06em',
    color: '#0F0F0F',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '32px 0px 0px',
    gap: '40px',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      fontSize: '22px',
    },
  }),
};
